import { ApiError } from '@/common/api/client'

/**
 * SMS opt-in copy (MRG-1140). Bump the version whenever the wording changes;
 * it must match CURRENT_SMS_CONSENT_COPY_VERSION in api/cash_offer_api/constants/sms_consent.py.
 */
export const SMS_CONSENT_COPY_VERSION = '2026-10-15'

export const SMS_CONSENT_PRIVACY_URL = 'https://orchard.com/privacy'
export const SMS_CONSENT_TERMS_URL = 'https://orchard.com/terms-of-use'

export interface SmsConsentRequest {
  consented: boolean
  copy_version: string
}

/** Shown when onboarding finishes but the opt-in was refused because the wording changed. */
export const SMS_CONSENT_STALE_ONBOARDING_MESSAGE =
  "Your text message opt-in wasn't saved because the wording changed. Refresh the page and opt in from Settings."

/** The API returns 409 when an opt-in was rendered with outdated wording. */
export function isSmsConsentWordingConflict(err: unknown): boolean {
  return err instanceof ApiError && err.status === 409
}
